import React from 'react';
import parse from 'html-react-parser';
import styles from './styles.scss';

const MailchimpFormEmbed = ({ data }) => (
  <div className={styles.articleBodyMailchimpFormEmbed}>{parse(data)}</div>
);

export default MailchimpFormEmbed;
